export default __webpack_public_path__ + "static/media/banner.7972469f.png";